export default __webpack_public_path__ + "static/media/MarketRealCase3-en.aa5be1fc.jpg";